import { useDispatch, useSelector } from "react-redux";
import { Biscuit } from '../../../../utils';

// eslint-disable-next-line no-unused-vars
const useLocations = ({ currentCity, setCurrentCity, select }) => {

  const dispatch = useDispatch();
  const resultLocation = useSelector(data => data.checkInTimes);

  const handleChangeLocation = val => {
    // remove url filter parameter of preselected location
    if (typeof window.__temp_filter_location_id !== 'undefined' && val.value != Number(window.__temp_filter_location_id)) {
      delete window.__temp_filter_location_id;
    }
    if(val === 'set'){
      dispatch({
        type: "PERIODS",
        link: `check_in_periods?location_id=55555555&sort=valid_from&direction=asc`,
        token: Biscuit.get('token')
      });
    } else {
      setCurrentCity(val.value);
      dispatch({
        type: "PERIODS",
        link: `check_in_periods?location_id=${val.value}&sort=valid_from&direction=asc`,
        token: Biscuit.get('token')
      });
    }

    dispatch({ type: "CLEAR_NEW_PERIODS" });
    dispatch({ type: "CLEAR_PATCHES" });
  };
  
  return {
    resultLocation,
    handleChangeLocation
  };
};

export default useLocations;
